




































































import Vue from 'vue';
import {Component} from 'vue-property-decorator'
import {Icon} from "@/helpers/icons";
import {UI} from "@/store/modules/ui";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import TdLogo from "@/components/TdLogo.vue";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import User from "@/models/user/User";
import CompanySimple from "@/models/company/CompanySimple";
import {Permissions} from "@/helpers/constants";
import Login from "@/views/login/Login.vue";
import LoginRequest from "@/models/auth/LoginRequest";
import TokenResult from "@/models/auth/TokenResult";

@Component({
	components: {Login, AsiAvatar, TdLogo},
})
export default class App extends Vue {

	private icons = Icon;
	private snackbarVisible: boolean = false;
	private snackbarMessage: SnackbarMessage | null = null;

	private get items(): object[] {
		const ret = [] as object [];

		ret.push({title: this.$t('pageTitles.home'), icon: Icon.home, route: {name: 'Home'}, exact: true});

		if (this.isCustomer) {
			ret.push({
				title: this.$t('uiTerms.myCompany'),
				icon: Icon.company,
				route: {name: 'Company', params: {id: this.company?.id ?? null}},
				exact: false
			});
		}

		ret.push(
			{title: this.$t('report.plural'), icon: Icon.reports, route: {name: 'Reports'}, exact: false},
		);

		if (this.isOffice || this.isCustomer) {
			ret.push(
				{title: this.$t('order.plural'), icon: Icon.orders, route: {name: 'Orders'}, exact: false},
			)
		}

		if (this.isOffice) {
			ret.push({
				title: this.$t('company.plural'),
				icon: Icon.companies,
				route: {name: 'Companies'},
				exact: false
			});
		}

		if (this.isOffice || this.isCustomer) {
			ret.push({title: this.$t('user.plural'), icon: Icon.users, route: {name: 'Users'}, exact: false});
		}
		if (this.isBilling || this.isCustomer) {
			ret.push({title: this.$t('bill.plural'), icon: Icon.bills, route: {name: 'Bills'}, exact: false})
		}
		if (this.isAdmin) {
			ret.push({title: this.$t('ui.export'), icon: Icon.export, route: {name: 'Export'}, exact: false});
		}

		return ret;
	}

	private get isAdmin(): boolean {
		return this.$store.getters['user/isAdmin'];
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isDriver(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightDriver);
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	private get user(): User | null {
		return this.$store.state.user.loggedInUser;
	}

	private get company(): CompanySimple | null {
		return this.user?.company ?? null;
	}

	private get currentLocale(): string {
		return this.$root.$i18n.locale;
	}

	private get isLoggedIn(): boolean {
		return this.$store.getters['user/isLoggedIn'];
	}

	private get snackbarDark(): boolean {
		return this.snackbarMessage?.dark ?? true;
	}

	private get snackbarTimeout(): number | null {
		return this.snackbarMessage?.timeout === undefined ? 5000 : this.snackbarMessage?.timeout;
	}

	private get avatarUrl(): string | null {
		return User.avatarUrlMedium(this.user);
	}

	private get fullName(): string | null {
		return User.fullName(this.user);
	}

	private mounted(): void {
		this.$store.commit('user/setIsRefreshingToken', false);

		this.$store.subscribe((mutation, state) => {
			if (mutation.type !== 'ui/showSnackbar') {
				return;
			}

			const uiState = state.ui as UI;
			this.snackbarMessage = uiState.snackbarMessage;
			this.snackbarVisible = true;
		});

		if (this.$store.getters['user/isLoggedIn']) {
			this.$store.dispatch('user/loadLoggedInUserData');
		} else if (this.$route.query.loginHash) {
			const loginHash: string | null | (string | null)[] = this.$route.query.loginHash;
			if (typeof loginHash === 'string') {
				this.$authService.login(LoginRequest.InstanceFromHash(loginHash))
					.then((tokenResult: TokenResult) => {
						this.$store.commit('user/setTokens', tokenResult);
						this.$store.dispatch('user/loadLoggedInUserData');
						this.$router.push(this.$route.path);
					})
					.catch(() => {
						this.$store.commit('ui/showSnackbar', {
							message: this.$t('snackbar.hashLoginError'),
							color: 'error',
						} as SnackbarMessage);
					});
			}
		}
	}

	private logout(): void {
		this.$store.dispatch('user/logout');

		if (this.$route.name !== 'Home') {
			this.$router.push({name: 'Home'});
		}
	}

	private openUserDetail(): void {
		if (this.user === null) return;
		this.$router.push({name: 'User', params: {id: this.user.id}}).catch(() => {
			//catching navigation to same route when already on own profile
		});
	}

}
